import { Headphones, Zap, Cpu, ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Motion";

const ITEMS = [
  { icon: Headphones, t: "Suporte 24h", d: "Assistência a qualquer hora." },
  { icon: Zap, t: "Agilidade", d: "Atendimento rápido pelo WhatsApp." },
  { icon: Cpu, t: "Tecnologia", d: "Apps próprios para celular, TV e computador." },
  { icon: ShieldCheck, t: "Confiança", d: "No mercado desde 2017." },
];

export const Differentials = () => (
  <section id="diferenciais" data-testid="differentials-section" className="border-t border-white/10">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-10 py-20 sm:py-28">
      <Reveal>
        <p className="text-xs tracking-[0.35em] text-cyan-300">DIFERENCIAIS</p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight">Por que escolher <span className="grad-text">a Speed Max?</span></h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {ITEMS.map(({ icon: I, t, d }, i) => (
          <Reveal key={t} delay={i * 0.08} className="h-full">
            <motion.div data-testid={`differential-${i}`} whileHover={{ y: -6 }} className="group h-full rounded-[22px] border border-white/10 bg-[#0e1120] p-7">
              <span className="grid h-12 w-12 place-items-center rounded-2xl grad-bg transition-transform duration-500 group-hover:rotate-[-8deg] group-hover:scale-110"><I className="h-6 w-6 text-white" strokeWidth={1.8} /></span>
              <h3 className="mt-6 font-display text-xl font-bold">{t}</h3>
              <p className="mt-2 text-sm text-zinc-300">{d}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
